import { networkApi } from '../infrastructure/api/NetworkApiClient';
import type { CrossZoneAlertEntry } from '../store/alertStore';
import { parseUtcTimestampMs } from '../utils/timeUtils';

interface CrossZoneAlertHistoryResponse {
  alertType: string;
  zoneId: string;
  zoneName: string;
  elementId: string | null;
  eventTimestamp: string;
  previousState: string | null;
  newState: string;
  metricValue: number | null;
  thresholdValue: number | null;
  source: string | null;
  triggerType: string | null;
  phase: string | null;
  elementType: string | null;
  elementName: string | null;
}

function toEntry(r: CrossZoneAlertHistoryResponse): CrossZoneAlertEntry {
  return {
    key: `${r.alertType}_${r.zoneId}_${r.elementId}_${r.eventTimestamp}`,
    type: r.alertType as CrossZoneAlertEntry['type'],
    zoneId: r.zoneId,
    zoneName: r.zoneName || r.zoneId,
    elementId: r.elementId,
    previousState: r.previousState,
    newState: r.newState,
    metricValue: r.metricValue ?? 0,
    thresholdValue: r.thresholdValue,
    source: r.source,
    triggerType: r.triggerType,
    phase: r.phase,
    elementType: r.elementType,
    elementName: r.elementName,
    timestamp: r.eventTimestamp,
    receivedAt: parseUtcTimestampMs(r.eventTimestamp),
    resolvedAt: null,
  };
}

class AlertService {
  async getAlertHistory(since = '24h', limit = 50): Promise<CrossZoneAlertEntry[]> {
    const data = await networkApi.httpGet<CrossZoneAlertHistoryResponse[]>(
      `/alerts/history?since=${encodeURIComponent(since)}&limit=${limit}`,
    );
    return data.map(toEntry);
  }
}

export const alertService = new AlertService();
